/**
 * Numeracja wypowiedzi.
 *
 * W bazie Utterance.index liczy sie od ZERA i tak ma zostac - to klucz stabilny
 * miedzy przebiegami, a zmiana bazy kosztowalaby migracje danych. Czlowiek i
 * model widza jednak numery od JEDNEGO: w poleceniu oceny ("[1] Anna: ..."), na
 * ekranie (numer przy wypowiedzi) i w pliku Word. Ten sam numer w trzech
 * miejscach to wymog, wiec przeliczenie siedzi w jednej funkcji i nigdzie indziej
 * nie wolno pisac `index + 1` ani `numer - 1` recznie.
 *
 * Czyste funkcje: zero DOM, zero API Node.
 */

/** Numer widoczny dla czlowieka i modelu (od 1) dla indeksu z bazy (od 0). */
export function numerWypowiedzi(index: number): number {
  return index + 1;
}

/** Odwrotnosc numerWypowiedzi: indeks z bazy (od 0) dla numeru od 1. */
export function indeksWypowiedzi(numer: number): number {
  return numer - 1;
}

/**
 * Czy numer (taki, jaki zwrocil model albo wpisal czlowiek) wskazuje istniejaca
 * wypowiedz: liczba calkowita od 1 do liczbaWypowiedzi wlacznie.
 */
export function czyNumerWypowiedziWZakresie(numer: unknown, liczbaWypowiedzi: number): numer is number {
  return typeof numer === "number" && Number.isInteger(numer) && numer >= 1 && numer <= liczbaWypowiedzi;
}
